@if (showError && !showSuccess) {
  <div class="automated-container">Gentile cliente, non è stato possibile completare l'acquisto. Contatta il Servizio clienti al n°800.44.33.22 dal lunedì al venerdì dalle 9 alle 19, oppure scrivi a consulenza.it&#64;redion.com</div>
}
@if (!showError && showSuccess) {
  <div class="automated-container">Grazie per il pagamento. La tua polizza sarà disponibile entro pochi minuti, ti chiediamo gentilmente di attendere.</div>
}
